<div class="hero-container reset-password-view d-flex vw-100 vh-100">
  <div class="emotional"></div>
  <div class="content d-flex flex-column justify-content-between vh-100">
    <div class="logo d-flex flex-row align-items-center">
      <img src="assets/hero/images/logo-hero.svg" alt="Hero" class="hero-logo" />
      <div class="vr"></div>
      <img src="assets/client/images/logo-client.svg" alt="Client" class="client-logo" />
    </div>
    <div class="">
      <h1 *ngIf="type=='password'" class="headline" dictionary="reset">Zurücksetzen.</h1>
      <h1 *ngIf="type=='signup'" class="headline" dictionary="confirm">Bestätigen.</h1>
      <host-reset-password
        [email]="email"
        [code]="code"
        (success)="success()"
        (failed)="fail($event)"
      ></host-reset-password>

    </div>
    <div class="powered-by">Powered by © Hero AI</div>
  </div>

</div>
